import React from 'react';
import { useSummaryDashboard } from '@/hooks';
import { SummaryCard, SummaryTypes } from '@/components/dashboard';
import { FinancialSummary } from '@/interfaces';

interface Props {
	summary?: FinancialSummary;
}

export const FinancialSummaryComponent: React.FC<Props> = ({ summary }) => {
	const { getSummaryOptions, getAmountByOption } = useSummaryDashboard();

	const initialStateSummary = getSummaryOptions();
	const [summaryOptions, setSummaryOptions] =
		React.useState(initialStateSummary);

	React.useEffect(() => {
		if (summary) {
			const options = summaryOptions.map((option) => {
				return getAmountByOption(option, summary);
			});
			setSummaryOptions(options);
		}
	}, [summary]);

	return (
		<div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4 gap-4">
			{summaryOptions.map((opt, index) => (
				<SummaryCard
					classNameText="capitalize"
					key={index}
					type={opt.type as SummaryTypes}
					quantity={opt.amount}
				/>
			))}
		</div>
	);
};
